import React from "react";

import Back from "../widgets/Back";

import { ViewTypes } from "../../constants/Constants";

export default class AppointmentCalendarRow extends React.Component {
  setView = (type) => {
    localStorage.setItem("rowView", type);

    this.forceUpdate();
  };

  render() {
    return (
      <div className="settings-body">
        <div className="title">
          <Back />
          <div className="name">Appointment calendar view</div>
        </div>
        <div className="body">
          <div className="list-group">
            <span onClick={() => this.setView(ViewTypes.compact)} className="list-group-item">
              {Boolean(localStorage.getItem("rowView") === ViewTypes.compact) && (
                <div className="pull-right">&#10004;</div>
              )}
              Compact View
            </span>
            <span onClick={() => this.setView(ViewTypes.comfort)} className="list-group-item">
              {Boolean(localStorage.getItem("rowView") === ViewTypes.comfort) && (
                <div className="pull-right">&#10004;</div>
              )}
              Comfortable View
            </span>
          </div>
        </div>
      </div>
    );
  }
}
